/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { WindDragCoefficient } from "./WindDragCoefficient";
import {
  WindDragCoefficientFromJSON,
  WindDragCoefficientFromJSONTyped,
  WindDragCoefficientToJSON,
  WindDragCoefficientToJSONTyped,
} from "./WindDragCoefficient";

/**
 *
 * @export
 * @interface PaginatedWindDragCoefficientList
 */
export interface PaginatedWindDragCoefficientList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<WindDragCoefficient>;
}

/**
 * Check if a given object implements the PaginatedWindDragCoefficientList interface.
 */
export function instanceOfPaginatedWindDragCoefficientList(
  value: object
): value is PaginatedWindDragCoefficientList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedWindDragCoefficientListFromJSON(
  json: any
): PaginatedWindDragCoefficientList {
  return PaginatedWindDragCoefficientListFromJSONTyped(json, false);
}

export function PaginatedWindDragCoefficientListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedWindDragCoefficientList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(WindDragCoefficientFromJSON),
  };
}

export function PaginatedWindDragCoefficientListToJSON(
  json: any
): PaginatedWindDragCoefficientList {
  return PaginatedWindDragCoefficientListToJSONTyped(json, false);
}

export function PaginatedWindDragCoefficientListToJSONTyped(
  value?: PaginatedWindDragCoefficientList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(WindDragCoefficientToJSON),
  };
}
